import {
  CONFIG_PASSOS_PROD,
  getInfoStep
} from './constants/constant_primeiros_passos';
import { IPrimeirosPassos } from './settings_primeiros_passos';

/**
 * MODULOS:
 * - PRODUCAO
 */
export class SettingsPrimeirosPassosProducao {
  passos = [
    {
      posicao: null,
      passo_valor: 'INFO_MATERIA_PRIMA',
      concluido: false,
      link: [
        {
          concluido: false,
          passo: 'CADASTRO_CATEGORIA_MP'
        },
        {
          concluido: false,
          passo: 'CADASTRO_VARIACAO_MP'
        },
        {
          concluido: false,
          passo: 'CADASTRO_MATERIA_PRIMA'
        }
      ]
    },
    {
      posicao: null,
      passo_valor: 'INFO_SERVICO',
      concluido: false,
      link: [
        {
          concluido: false,
          passo: 'CADASTRO_CATEGORIA_SERVICO'
        },
        {
          concluido: false,
          passo: 'CADASTRO_SERVICO'
        }
      ]
    },
    {
      posicao: null,
      passo_valor: 'INFO_PRODUCAO',
      concluido: false,
      link: [
        {
          concluido: false,
          passo: 'CADASTRO_PRIORIDADE'
        },
        {
          concluido: false,
          passo: 'CADASTRO_NIVEL'
        },
        {
          concluido: false,
          passo: 'CADASTRO_TP_ERRO_PROD'
        },
        {
          concluido: false,
          passo: 'CADASTRO_LINHA_MONTAGEM'
        },
        {
          concluido: false,
          passo: 'CADASTRO_PECA'
        },
        {
          concluido: false,
          passo: 'CADASTRO_ETAPA'
        },
        {
          concluido: false,
          passo: 'CADASTRO_PROCESSO'
        },
        {
          concluido: false,
          passo: 'CADASTRO_MODELO'
        }
      ]
    }
  ] as IPrimeirosPassos[];

  ultimo_passo = 'UNKNONW';

  constructor(
    public configInicial: {
      passos: IPrimeirosPassos[];
      ultimo_passo: string;
    }
  ) {
    var count = 0;
    this.passos.forEach(it => {
      const index = configInicial.passos.findIndex(
        it2 => it2.passo_valor === it.passo_valor
      );
      if (index === -1) {
        configInicial.passos.push(it);
      }
    });
    configInicial.passos.forEach(it => {
      if (it.posicao !== null) count = it.posicao + 1;
      it.posicao = it.posicao !== null ? it.posicao : count++;
    });
    this.passos = configInicial.passos;
    this.ultimo_passo = configInicial.ultimo_passo;
  }

  getSettingsPassosProducao(config_inicial: {
    passos: IPrimeirosPassos[];
    ultimo_passo: string;
  }) {
    return {
      passos: getInfoStep(this.passos, CONFIG_PASSOS_PROD),
      ultimo_passo: this.ultimo_passo
    };
  }
}
